<template>
  <div class="stk-px-8">
    <NoteTaking :meeting-id-query-param="meetingIdQueryParam" />
  </div>
</template>

<script>
import NoteTaking from '@frontend/ui/features/example/views/NoteTaking.vue';

export default {
  name: 'SingleMeeting',
  props:{
    meetingIdQueryParam: {
      type: [String, Number],
      required: true,
    },
  },
  components: {
    NoteTaking,
  },
}
</script>
